module.exports = __webpack_public_path__ + "img/icon-warning-flom-4.1db8cc08.svg";